
import React from "react";
import { Badge } from "@/components/ui/badge";

interface StatusBadgeProps {
  status: 'pending' | 'under_review' | 'approved' | 'rejected';
}

const getStatusBadge = (status: string) => {
  const statusConfig = {
    pending: { label: "Pending", className: "bg-blue-100 text-blue-800" },
    under_review: { label: "Under Review", className: "bg-yellow-100 text-yellow-800" },
    approved: { label: "Approved", className: "bg-green-100 text-green-800" },
    rejected: { label: "Rejected", className: "bg-red-100 text-red-800" },
  };

  const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.pending;
  return <Badge className={config.className}>{config.label}</Badge>;
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  return getStatusBadge(status);
}
